import CloseIcon from "@mui/icons-material/Close"
import { Button, IconButton, Snackbar } from "@mui/material"
import { ReactElement } from "react"
import { useNavigate } from "react-router-dom"

import { CHANGE_LOG } from "../../router/routes"

// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore: Unreachable code error
// eslint-disable-next-line no-undef
const CONFIG = GLOBAL_CONFIG

interface IReleaseSnackbarProps {
    open: boolean
    setOpen: (open: boolean) => void
}

/**
 * Snackbar component that displays a message about a new release
 *
 * @param {boolean} open - whether the snackbar is open
 * @param {function} setOpen - function to set the state of the snackbar
 */
const ReleaseSnackbar = ({
    open,
    setOpen,
}: IReleaseSnackbarProps): ReactElement => {
    const navigate = useNavigate()
    const handleClose = (): void => {
        setOpen(false)
    }

    const message = (
        <>
            API v2 Migration - API users: Please review the API v2 Migration
            Guide for full details of the changes coming in September
        </>
    )

    const changeLog = (): void => {
        navigate(CHANGE_LOG)
    }
    const action = (
        <>
            <Button
                color="secondary"
                size="small"
                sx={{ textTransform: "none" }}
                onClick={changeLog}
            >
                View Change Log
            </Button>
            <IconButton
                size="small"
                aria-label="close"
                color="inherit"
                onClick={handleClose}
            >
                <CloseIcon fontSize="small" />
            </IconButton>
        </>
    )

    return (
        <Snackbar
            open={open}
            autoHideDuration={9000}
            onClose={handleClose}
            message={message}
            action={action}
        />
    )
}

export default ReleaseSnackbar
